// src/services/OrderServices.js
import { apiService } from './apiService';

export function getOrderService(data) {
  return apiService({
    method: 'POST',
    url: '/order/data',
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function getByIdOrderService(id) {
  return apiService({
    method: 'GET',
    url: '/order/' + id,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function addOrderService(data) {
  return apiService({
    method: 'POST',
    url: '/order',
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function updateOrderService(id, data) {
  return apiService({
    method: 'PUT',
    url: '/order/' + id,
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function deleteOrderService(id) {
  return apiService({
    method: 'DELETE',
    url: '/order/' + id,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function addTableOrderService(data) {
  return apiService({
    method: 'POST',
    url: '/front/order',
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function getByTableIdOrderService(id) {
  return apiService({
    method: 'GET',
    url: '/front/order/' + id,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

export function getPopularItemsService(params = {}) {
  return apiService({
    method : 'GET',
    url    : '/order/popular',
    params,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

/**
 * Kitchen Board (uses kitchen-only permission)
 * Backend route mounted under /api/order ⇒ POST /api/order/kitchen
 */
export function getKitchenOrdersService(data = { mode: 'ALL' }) {
  return apiService({
    method : 'POST',
    url    : '/order/kitchen',
    data,
    onSuccess: () => {},
    onFailure: () => {},
  });
}

/**
 * Optional: bump status from the kitchen board (if you have this)
 */
export function updateKitchenOrderStatusService(id, newStatus) {
  return apiService({
    method : 'PUT',
    url    : `/admin/kitchen/order/${id}/status`,
    data   : { newStatus },
    onSuccess: () => {},
    onFailure: () => {},
  });
}
